$(document).ready(function(){
    $('form.ajax-submit').submit(function(){
        if(!$(this).hasClass('loading')){
            var form = $(this);
            var formType = form.data('form-type');

            form.addClass('loading');
            form.find('.loading_off').hide();
            form.find('.loading_on').show();

            var submitData = new Object();

            submitData['json'] = true;

            form.find('input, textarea, select').each(function(){
                if($(this).attr('name')){
                    submitData[$(this).attr('name')] = $(this).val();
                }
            });

            submitData['isJson'] = true;

            $.ajax({
                type: "POST",
                url: form.attr('action'),
                data: submitData,
                dataType: "json",
                error: function(response, error){
                    if(grecaptcha){
                        grecaptcha.reset();
                    }

                    form.removeClass('loading');
                    form.find('.loading_on').hide();
                    form.find('.loading_off').show();
                    alert("An unexpected error occured. Please try again later")
                },
                success: function(response){
                    alertMsg = "";
                    if(response.errors){
                        for(i in response.errors){
                            alertMsg += " - " + response.errors[i] + "\n";
                        }
                    }

                    if(alertMsg){
                        if(grecaptcha){
                            grecaptcha.reset();
                        }

                        alert("The following errors occurred:\n" + alertMsg);
                    }
                    else {
                        if(response.redirect){
                            window.location = response.redirect;
                        } else if(response.form_replace_html){
                            form.slideUp('fast',function(){
                                form.html(response.form_replace_html);
                                form.slideDown('fast');
                            });
                        }
                        else {
                            if(response.evaluate){
                                eval(response.evaluate);
                            }
                            else {
                                alert('Thank you. Your details have been saved.');
                            }
                            if(typeof _gaq !== 'undefined') {
                                _gaq.push(['_trackEvent', 'Forms', 'Submit', formType]);
                            }

                        }
                    }
                    form.find('.loading_on').hide();
                    form.find('.loading_off').show();
                    form.removeClass('loading');
                }
            });
        }

        return false;
    });
});